var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from "@emotion/css";
import LeftNavigation from "./LeftNavigation/LeftNavigation";
import RightNavigation from "./RightNavigation/RightNavigation";
var MainNavigation = function () {
    return (_jsxs("div", __assign({ className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        position: relative;\n        height: 56px;\n        display: flex;\n        -webkit-box-pack: justify;\n        justify-content: space-between;\n        -webkit-box-align: center;\n        align-items: center;\n      "], ["\n        position: relative;\n        height: 56px;\n        display: flex;\n        -webkit-box-pack: justify;\n        justify-content: space-between;\n        -webkit-box-align: center;\n        align-items: center;\n      "]))) }, { children: [_jsx(LeftNavigation, {}), _jsx(RightNavigation, {})] })));
};
export default MainNavigation;
var templateObject_1;
